import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useArticles } from '../context/ArticleContext';
import SEO from '../components/SEO';
import RelativeTime from '../components/RelativeTime';
import { safeAlt, stripHtml, truncate } from '../utils/seoUtils';
import './ArticlePage.css';



function ArticlePage() {
  const { id } = useParams();
  const { currentArticle, loading, error, fetchArticle } = useArticles();

  useEffect(() => {
    if (id) {
      fetchArticle(id);
    }
  }, [id]);

  if (loading) {
    return <div className="article-container"><div className="loading">Loading article...</div></div>;
  }

  if (error) {
    return <div className="article-container"><div className="error">Error: {error}</div></div>;
  }

  if (!currentArticle) {
    return <div className="article-container"><div className="error">Article not found</div></div>;
  }

  const desc = currentArticle.subtitle
    ? truncate(stripHtml(currentArticle.subtitle), 160)
    : truncate(stripHtml(currentArticle.excerpt || currentArticle.content || ""), 160);

  return (
    <div className="article-container">
      <SEO
        type="article"
        url={`/article/${currentArticle.id}`}
        title={currentArticle.title}
        description={desc}
        image={currentArticle.image}
        imageAlt={safeAlt({
          title: currentArticle.title,
          category: currentArticle.category,
          authorByline: currentArticle.authorByline,
          author: currentArticle.author,
        })}
        publishedTime={currentArticle.fullDate}
        modifiedTime={currentArticle.fullDate}
        authorName={currentArticle.authorByline || currentArticle.author}
        section={currentArticle.category}
        tags={currentArticle.tags || currentArticle.wpTags || []}
      />

      <div className="article-header">
        <span className="category">{currentArticle.category}</span>
        <h1 className="article-title full-title">{currentArticle.title}</h1>
        {currentArticle.subtitle && (
          <p className="article-subtitle">{currentArticle.subtitle}</p>
        )}
        <div className="article-byline">
          <div className="author-name">{currentArticle.authorByline}</div>
          <RelativeTime date={currentArticle.createdAt || currentArticle.publishTime || currentArticle.fullDate || currentArticle.date} className="publish-time" />
        </div>

      </div>

      <img
        src={currentArticle.image}
        alt={safeAlt({
          title: currentArticle.title,
          category: currentArticle.category,
          authorByline: currentArticle.authorByline,
          author: currentArticle.author,
        })}
        className="article-img"
      />

      <div className="article-content">
        <div dangerouslySetInnerHTML={{ __html: currentArticle.content }} />
      </div>
    </div>
  );
}

export default ArticlePage;